// Design tokens used in JavaScript (CSS variables handle the rest in global.css)
export const tokens = {
  layout: {
    maxWidth: "1320px",
    mobileBreakpoint: "768px",
  },
};
